/* Translate known public copy only. No visitor text leaves the storefront. */
(function () {
  'use strict';
  var script = document.currentScript;
  if (!script || !script.dataset.dictionary || window.__fjordlightingPublicText) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (/\/(?:account|checkout|checkouts)(?:\/|$)/.test(location.pathname)) return;
  window.__fjordlightingPublicText = true;
  var normalize = function (value) { return value.replace(/\s+/gu, ' ').trim(); };
  var excluded = 'script,style,noscript,code,pre,svg,math,textarea,[contenteditable],'
    + '[translate="no"],[data-no-auto-translate],.notranslate,.material-icons,'
    + '.material-icons-outlined,.material-icons-round,.material-icons-sharp,'
    + '.material-icons-two-tone,.material-symbols-outlined,.icon,.money,.price';
  var attributes = ['alt', 'title', 'placeholder', 'aria-label'];
  var written = new WeakMap();
  var queue = new Set();
  var scheduled = false;

  fetch(script.dataset.dictionary, { credentials: 'omit' })
    .then(function (response) { if (!response.ok) throw new Error('Dictionary unavailable'); return response.json(); })
    .then(function (dictionary) {
      if (dictionary.version !== 1 || dictionary.locale !== script.dataset.locale || !dictionary.entries) return;
      var entries = dictionary.entries;
      var replace = function (value) {
        var key = normalize(value);
        var translated = Object.prototype.hasOwnProperty.call(entries, key) ? entries[key] : null;
        return typeof translated === 'string' && translated && translated !== key
          ? value.match(/^\s*/u)[0] + translated + value.match(/\s*$/u)[0] : value;
      };
      var visitText = function (node) {
        if (!node.parentElement || node.parentElement.closest(excluded)) return;
        if (written.get(node) === node.nodeValue) return;
        var next = replace(node.nodeValue || '');
        if (next !== node.nodeValue) { written.set(node, next); node.nodeValue = next; }
      };
      var visitElement = function (element) {
        if (element.closest(excluded)) return;
        attributes.forEach(function (name) {
          if (!element.hasAttribute(name)) return;
          var value = element.getAttribute(name);
          var last = written.get(element) || {};
          if (last[name] === value) return;
          var next = replace(value);
          if (next !== value) {
            last[name] = next; written.set(element, last); element.setAttribute(name, next);
          }
        });
      };
      var scan = function (root) {
        if (!root.isConnected) return;
        if (root.nodeType === 3) { visitText(root); return; }
        if (root.nodeType !== 1 || root.closest(excluded)) return;
        visitElement(root);
        var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
          acceptNode: function (node) {
            return node.nodeType === 1 && node.matches(excluded) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
          }
        });
        while (walker.nextNode()) {
          if (walker.currentNode.nodeType === 3) visitText(walker.currentNode);
          else visitElement(walker.currentNode);
        }
      };
      var flush = function () {
        scheduled = false;
        var roots = queue; queue = new Set();
        roots.forEach(function (root) {
          for (var parent = root.parentNode; parent; parent = parent.parentNode) {
            if (roots.has(parent)) return;
          }
          scan(root);
        });
      };
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList') mutation.addedNodes.forEach(function (node) { queue.add(node); });
          else queue.add(mutation.target);
        });
        if (!scheduled && queue.size) { scheduled = true; requestAnimationFrame(flush); }
      });
      scan(document.body);
      observer.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: attributes });
    })
    // Native translations and the original copy remain usable during a failed
    // CDN request. Never hide the page or replace it with a loading state.
    .catch(function () {});
})();
